<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kislET/tc-custom/FC-9781788485852.jpg?1684515200406?1725649949909" alt="This image is the cover for the book Hallowed Be My Name"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hallowed Be My Name
      </h1>
      <p class="bookDescription body article font2">
        <p>Matthew 10:28 – And do not fear those who kill the body but cannot kill the soul. Rather fear him who can destroy both soul and body in hell. They never knew such evil could exist within this loving and happy home, the house of their dreams with such character and future life. This is not true, these things don't happen in real life and not to us.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tony Antoniou
      </h2>
      
      <p class="authorDescription body article">The author was born in London, as a first-generation immigrant, to a Greek Cypriot family. Tony and his siblings struggled to adapt to the culture clash of British life and traditions, but out of this confusion, many talents and colourful personalities within the family unit came to the fore. His mother had a beautiful voice so it was destined that Tony went on to have a semi-professional career in singing and writing. Tony was a drama student at high school and was involved in playing many diverse parts and was also involved in some production work, but soon developed a love of music. He had a good singing voice so he made the choice to find a career in something he loved rather than treading the boards. He auditioned for the singing parts around London with various bands with diverse styles but eventually joined a jazz funk band from North West London as their frontman, lead singer and rhythm guitarist. The band were hailed as leaders in the forefront of the Brit jazz funk music movement at that time, with a unique electro funk sound and style which came from their first release, they were also revered across the water in the New York club scene. But in the early 80s and with battling egos, Tony decided to embark on a solo career as a singer songwriter and was signed by a major label to release an album and singles, in which he found some success. “I wanted to move on and develop my own sound and write songs for myself and for others to perform. It takes an incredible amount of luck and being in the right place to get your foot in the door and I didn’t get the real break I needed to make it.” After being disenchanted by the new style of bubble gum music that was hitting the charts, he decided to hand up his microphone. “Sometimes life gets in the way of your dreams”</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?40b869b1